import React from 'react';
import { useAppSelector } from 'src/hooks/store';
import { Icon, IconType } from '../base/Icon';
var InstitutionLogoHeader = function (_a) {
    var _b;
    var children = _a.children;
    var widget = useAppSelector(function (state) { return state.widget; });
    var _c = (widget === null || widget === void 0 ? void 0 : widget.institution) || {}, uniUrl = _c.website_url, avatar = _c.avatar, name = _c.name;
    var avatarUrl = ((_b = avatar === null || avatar === void 0 ? void 0 : avatar.sizes) === null || _b === void 0 ? void 0 : _b['70x70']) || (avatar === null || avatar === void 0 ? void 0 : avatar.original);
    var renderLogoLink = function (content) {
        return uniUrl ? (React.createElement("a", { href: uniUrl, target: "_blank", rel: "noopener noreferrer", "aria-label": "Navigate to the website" }, content)) : (content);
    };
    return (React.createElement("div", { className: "institution-logo-header-container" },
        renderLogoLink(avatarUrl ? (React.createElement("img", { className: "institution-logo-header-container-image", src: avatarUrl, alt: "Logo" })) : (React.createElement(Icon, { type: IconType.UniDefault, className: "size-8 md:size-14" }))),
        React.createElement("div", { className: "institution-logo-header-divider" }),
        renderLogoLink(React.createElement("div", { className: "institution-logo-header-name" }, name || '')),
        children));
};
export default InstitutionLogoHeader;
